var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"w-100 h-100"},[_c('Nav')],1),_c('div',{staticClass:"content h-100",staticStyle:{"background":"white"}},[_c('Home')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }